<template>
  <div id="permission">
    <div class="title">权限组管理</div>
    <div class="permission-container">
      <div class="container-tip">
        <svg-icon icon-class="icon-tips" class="icon-tips" />
        <ul>
          <svg-icon icon-class="tips-bg" class="icon-tips-bg" v-if="showTips" />
          <li class="tips-tit">
            小贴士
            <i
              class="el-icon-caret-top tips-btn"
              v-if="showTips"
              @click="showTip"
            ></i>
            <i
              class="el-icon-caret-bottom tips-btn"
              v-else
              @click="showTip"
            ></i>
          </li>
          <li v-if="showTips">
            <span></span>
            <div>
              创建权限组时，请按照实际业务角色创建，根据角色具体用到的功能进行配置
            </div>
          </li>
          <li v-if="showTips">
            <span></span>
            <div>
              创建权限组时，请尽量填写权限组描述，当权限组名称类似时，可以区分其不同
            </div>
          </li>
        </ul>
      </div>
      <div class="container-main">
        <div class="main-left">
          <div class="left-operation">
            <div class="operation-btn">
              <el-tooltip
                placement="top"
                popper-class="custom-tooltip"
                effect="light"
              >
                <div slot="content">添加权限组</div>
                <div @click="addPermission">
                  <svg-icon icon-class="add-ico" class="btn-add" />
                </div>
              </el-tooltip>
              <el-tooltip
                placement="top"
                popper-class="custom-tooltip"
                effect="light"
              >
                <div slot="content">删除</div>
                <div @click="delPermission">
                  <svg-icon icon-class="del-ico" class="btn-del" />
                </div>
              </el-tooltip>
            </div>
            <el-input
              class="operation-search"
              placeholder="请输入权限组名称"
              suffix-icon="el-icon-search"
              v-model="search"
              clearable
              v-if="group.length"
            ></el-input>
          </div>
          <ul class="group-list">
            <li
              class="permission"
              v-for="(item, index) in group"
              :key="index"
              :class="{ 'active-group': groupOpration == index }"
              @click="selectGroup(index, item)"
            >
              <span>{{ item.name }}</span>
            </li>
          </ul>
        </div>

        <div class="main-right" v-if="group.length || operation == 'create'">
          <basic-info
            ref="basicInfo"
            class="basic-info"
            :operation="operation"
            :groupInfo="groupInfo"
            @createPermission="changePermission($event)"
          ></basic-info>
          <permission-list
            class="permission-list"
            :roleId="groupInfo.id"
            v-if="operation != 'create'"
          ></permission-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import basicInfo from "./basic-info";
import permissionList from "./permissionList";
import { getAllRoles, deleteRole } from "@/http/api/role";
import { deepCopy } from "@/utils/deepCopy";

export default {
  components: {
    basicInfo,
    permissionList,
  },
  data() {
    return {
      permissions: this.$store.getters.permissions, //用户权限集合
      search: "",
      groupOpration: 0,
      group: [],
      operation: "",
      defaultProps: {
        children: "children",
        label: "name",
      },
      groupInfo: {
        name: "",
        isDefault: false,
        isPublic: true,
        status:true,
        describe: "",
      },
      showTips: true,
      permissionNode: {},
    };
  },
  mounted() {
    this.getAllRoleList();
  },
  methods: {
    showTip() {
      this.showTips = !this.showTips;
    },
    getAllRoleList() {
      getAllRoles().then((res) => {
        this.group = res.result.items;
        this.groupInfo = deepCopy(
          this.group.length ? this.group[this.groupOpration] : {}
        );
      });
    },
    selectGroup(index, item) {
      this.groupOpration = index;
      this.groupInfo = deepCopy(item);
      this.operation = "checked";
    },
    // 删除节点
    delPermission() {
      if (this.groupInfo.isDefault) {
        this.$message.warning({
          message: `默认权限组不可删除`,
          showClose: true,
        });
      } else {
        if (this.permissions["RocketIdentity.Roles.Delete"]) {
          this.$confirm(
            `是否删除${this.group[this.groupOpration].name}？`,
            `删除${this.group[this.groupOpration].name}`,
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }
          )
            .then(() => {
              deleteRole(this.group[this.groupOpration].id)
                .then((res) => {
                  if (res.code == 10200) {
                    this.getAllRoleList();
                    this.$message.success({ message: res.message });
                  } else {
                    this.$message.warning({ message: res.message });
                  }
                })
                .catch((err) => {
                  this.$message.error({ message: err.message });
                });
            })
            .catch(() => {
              this.$message({
                message: "取消删除",
                showClose: true,
              });
            });
        } else {
          this.$message.warning({
            message: `您暂无删除权限组权限`,
            showClose: true,
          });
        }
      }
    },
    addPermission() {
      if (this.permissions["RocketIdentity.Roles.Create"]) {
        this.operation = "create";
        this.groupInfo = {
          name: "",
          isDefault: false,
          isPublic: true,
          describe: "",
        };
      } else {
        this.$message.warning({
          message: `您暂无创建权限组权限`,
          showClose: true,
        });
      }
    },
    changePermission() {
      this.getAllRoleList();
      this.groupInfo = {
        name: "",
        isDefault: false,
        isPublic: true,
        describe: "",
      };
      this.operation = "checked";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
#permission {
  min-height: calc(100vh - 330px);
  // overflow-y: auto;
  .title {
    color: #000000;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding: 17px 20px 17px;
    background: rgba(255, 255, 255, 1);
  }

  .svg-icon {
    cursor: pointer;
  }

  .permission-container {
    .container-tip {
      @include flex(row, flex-start);
      margin-bottom: 20px;
      padding: 20px;
      font-size: 12px;
      font-weight: 500;
      background: #fff;
      .icon-tips {
        color: $--color-primary;
        padding: 10px 0;
      }
      ul {
        margin: 0;
        position: relative;
        padding-left: 10px;
        width: 100%;
        .icon-tips-bg {
          position: absolute;
          right: 0px;
          bottom: -94px;
          font-size: 250px;
        }
        li {
          @include flex(row, center);
          margin-bottom: 10px;
          width: 100%;
          span {
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
            padding: 2px;
            background: #111;
          }
        }
        .tips-tit {
          justify-content: space-between;
          .tips-btn {
            position: relative;
            z-index: 99;
            padding: 10px;
            cursor: pointer;
          }
        }
        li:last-child {
          margin-bottom: 0px;
        }
      }
    }

    .container-main {
      display: flex;
      min-height: calc(100vh - 160px);

      .main-left {
        border-radius: $--border-radius-base;
        padding: 20px;
        border-radius: $--border-radius-base;
        width: 315px;
        background: #fff;

        .left-operation {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .operation-btn {
            display: flex;
            align-items: center;
            justify-content: space-between;

            width: 50px;

            .btn-add {
              width: 10px;
              height: 10px;
            }

            .btn-del {
              width: 16px;
              height: 16px;
              color: #888;
            }
          }

          .operation-search {
            width: 220px;
            height: 30px;
          }
        }
        .group-list {
          padding-inline-start: 0;
          text-align: left;
          .permission {
            @include flex(row, center);
            width: 305px;
            height: 35px;
            padding-left: 9px;
            font-size: 12px;
            cursor: pointer;
            color: #000000;
          }
          .active-group {
            background: #e5e5e5;
          }
        }
      }

      .main-right {
        border-radius: $--border-radius-base;
        margin-left: 20px;
        overflow: hidden;
        width: calc(100% - 354px);

        .basic-info,
        .permission-list {
          margin-bottom: 20px;
          border-radius: $--border-radius-base;
          background: #fff;
        }
        .permission-list {
          margin-bottom: 0px;
        }
      }
    }
  }

  @media (max-width: 1600px) {
    .permission-container {
      padding: 20px;
    }
  }

  @media (min-width: 1600px) and (max-width: 1920px) {
    .permission-container {
      padding: 20px 100px;
    }
  }

  @media (min-width: 1920px) {
    .permission-container {
      padding: 20px 180px;
    }
  }
}
</style>